import request from "@/utils/request";

// 登录方法
export function login(data) {
  return request({
    url: "/auth/login/loginByPassword",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
    // params: data,
  });
}

// 发送手机验证码
export function sendSms(data) {
  return request({
    url: "/auth/login/sendSmsCodeByUsername",
    method: "get",
    params: data,
  });
}

// 注册方法
export function register(data) {
  return request({
    url: "/auth/login/registUser",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/system/user/getInfo",
    method: "get",
  });
}

// 退出方法
export function logout() {
  return request({
    url: "/auth/logout",
    method: "delete",
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: "/code",
    headers: {
      isToken: false,
    },
    method: "get",
    timeout: 20000,
  });
}

// 获取忘记密码验证码
export function getResetPassWordCode(data) {
  return request({
    url: "/auth/login/resetSendCode",
    method: "post",
    params: data,
  });
}

// 发送手机验证码
export function sendCode(data) {
  return request({
    url: "/auth/login/registSendCode",
    method: "post",
    params: data,
  });
}

// 忘记密码提交
export function ResetPassWord(data) {
  return request({
    url: "/auth/login/forgetPassword",
    headers: {
      isToken: false,
    },
    method: "post",
    // params: data,
    data: data,
  });
}

// 修改密码
export function updataPassWord(data) {
  return request({
    url: "/auth/login/updatePassword",
    method: "put",
    // params: data,
    data: data,
  });
}
